import React, { useEffect, useState, FunctionComponent } from 'react';
import ClientDataExchange from '../../presentational/ClientDataExchange/ClientDataExchange';
import {
	FinancialPlanningSoftware,
	EpiAccount,
	EpiAccountDoesNotExist,
} from '../../../logic/domains/epi.domain';
import { getProducts } from '../../../logic/functions/epiProducts.function';
import { getAccount } from '../../../logic/functions/epiAccounts.function';
import Introduction from '../../presentational/ClientDataExchange/Introduction/Introduction';
import Account from '../../presentational/ClientDataExchange/Account/Account';
import Help from '../../presentational/ClientDataExchange/Common/Help';
import InactiveAccount from '../../presentational/ClientDataExchange/Account/InactiveAccount';
import ViewAccount from '../../presentational/ClientDataExchange/Account/ViewAccount';
import CreateAccount from '../../presentational/ClientDataExchange/Account/CreateAccount';
import { useAdviserDetails } from '../../hooks/AppStateHook';

const ClientDataExchangeContainer: FunctionComponent = () => {
	const [loading, setLoading] = useState(true);
	const [account, setAccount] = useState<EpiAccount>();
	const [fpsOptions, setFpsOptions] = useState<FinancialPlanningSoftware[]>([]);
	const { customerToken } = useAdviserDetails();

	useEffect(() => {
		const fetchData = async () => {
			const products = await getProducts();
			const account = await getAccount(customerToken);
			setFpsOptions(products);
			setAccount(account);
			setLoading(false);
		};
		customerToken && fetchData();
	}, [customerToken]);

	const Notification = ({ account }: { account?: EpiAccount }) =>
		account && !account.isActive ? <InactiveAccount /> : null;

	const View = ({ account }: { account?: EpiAccount }) =>
		account === EpiAccountDoesNotExist ? (
			<CreateAccount
				fpsOptions={fpsOptions}
				onComplete={setAccount}
				token={customerToken}
			/>
		) : (
			<ViewAccount
				fpsOptions={fpsOptions}
				account={account}
				token={customerToken}
			/>
		);

	return (
		<ClientDataExchange>
			<Notification account={account} />
			<Introduction />
			<Account loading={loading}>
				<View account={account} />
			</Account>
			<Help />
		</ClientDataExchange>
	);
};

export default ClientDataExchangeContainer;
